import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const takeScrapperProtected = createAsyncThunk(
    "scrapper/takeScrapper-protected",
    async ({ formData, token }, { rejectWithValue }) => {
        try {

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/html-scraper/pass-protected-website`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue(response.data.message);
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);

export const ScrapermoveInFolder = createAsyncThunk(
    "scraper/moveInFolder",
    async ({ token, folderId, id }, { rejectWithValue }) => {


        try {

            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/html-scraper/folders/move-in-folder`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        htmlId: id, folderId
                    }
                }
            );

            if (response.data.status) {
                // console.log(response.data.response);
                return {id,folderId,response:response.data.response};
            } else {
                return rejectWithValue("Failed to Add in folder");
            }
        } catch (error) {

            return rejectWithValue(
                error.response?.data || "Error to add in folder "
            );
        }
    }
);

export const toggleKeyStatusScraper = createAsyncThunk(
    "scraper/toggleKeyStatusscraper",
    async ({ key, token }, { rejectWithValue }) => {

        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/html-scraper/${key}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },

                }
            );

            if (response.data.status) {

                return { key: key, response: response.data.response };
            } else {
                return rejectWithValue("Failed to toggle key status");
            }
        } catch (error) {

            return rejectWithValue(
                error.response?.data || "Error toggling key status"
            );
        }
    }
);

export const deleteScrapper = createAsyncThunk(
    "scrapper/delete-Scrapper",
    async ({ token, id }, { rejectWithValue }) => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_BASE_URL}/html-scraper/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },

                }
            );

            if (response.data.status) {
                // console.log(response.data.response)
                return { id: id, response: response.data.response };
            } else {
                return rejectWithValue("Failed to delete scrapper");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);

export const getScrapper = createAsyncThunk(
    "Scrapper/getScrapper",
    async ({ token, offset = 1, limit = 10, onlyMy }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/html-scraper/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { offset, limit, onlyMy },
                }
            );

            if (response.data.status) {
                return response.data.response;
            } else {
                return rejectWithValue("Failed to fetch screenshots");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);

export const takeScrapper = createAsyncThunk(
    "scrapper/takeScrapper",
    async ({ formData, token }, { rejectWithValue }) => {
        try {
            console.log(formData)
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/html-scraper/try`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue(response.data.message);
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);


const initialState = {
    data: [],
    isLoading: false,
    error: null,
};

const ScrapperSlice = createSlice({
    name: "scrapper",
    initialState,
    reducers: {
        addDummyScraper: (state, action) => {
            state.data.unshift(action.payload)
        },
        removeDummyScraper: (state, action) => {
            state.data.shift()
        },
        clearScraper: (state) => {
            state.data = []
        },
        removeFromFolderScrapper: (state, action) => {
            const scrap = state.data.find(scrap => scrap.key === action.payload.key);
            if (scrap) {
                scrap.folderId = null;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(takeScrapper.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(takeScrapper.fulfilled, (state, action) => {
                state.isLoading = false;

            })
            .addCase(takeScrapper.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                toast.error(action.payload);

            })
            .addCase(getScrapper.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getScrapper.fulfilled, (state, action) => {
                state.isLoading = false;

                const { offset } = action.meta.arg;

                if (offset === 1) {

                    state.data = action.payload;
                } else {

                    const combined = [...state.data, ...action.payload];
                    const unique = Array.from(new Map(combined.map(scrapper => [scrapper.key, scrapper])).values());
                    state.data = unique;
                }


                // toast.success("Scraper fetched successfully!");

            })
            .addCase(getScrapper.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                // toast.error("Failed to fetch Scraper");
            })
            .addCase(deleteScrapper.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteScrapper.fulfilled, (state, action) => {
                state.isLoading = false;

                state.data = state.data.filter(
                    (scrap) => scrap.key !== action.payload.id
                );
                toast.success(action.payload.response);
            })
            .addCase(deleteScrapper.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to delete screenshot.");
            })
            .addCase(toggleKeyStatusScraper.pending, (state) => {
                state.isLoading = true
            })
            .addCase(toggleKeyStatusScraper.fulfilled, (state, action) => {
                state.isLoading = false
                if (typeof action.payload === "object" && action.payload?.key) {
                    state.data = state.data.map((scrap) =>
                        scrap.key === action.payload.key
                            ? { ...scrap, status: scrap.status === 1 ? 0 : 1 }
                            : scrap
                    );
                    toast(action.payload.response);
                }
            })

            .addCase(toggleKeyStatusScraper.rejected, (state, action) => {
                state.isLoading = false
                toast.error(action.payload || "Failed to toggle key status");
            })
            .addCase(ScrapermoveInFolder.pending, (state, action) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(ScrapermoveInFolder.fulfilled, (state, action) => {
                state.isLoading = false
                const scrap= state.data.find(scrap => scrap.htmlId === action.payload.id);
                if (scrap) {  
                    scrap.folderId = action.payload.folderId;
                  }
                toast(action.payload.response)
            })
            .addCase(ScrapermoveInFolder.rejected, (state, action) => {
                state.isLoading = false
                toast(action.payload)
            })
            .addCase(takeScrapperProtected.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(takeScrapperProtected.fulfilled, (state, action) => {
                state.isLoading = false;
                toast.success("Scraper taken successfully!");
            })
            .addCase(takeScrapperProtected.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                toast.error("Error in taking Scraper Please try again later ")
            });


    },
});

export const { addDummyScraper, removeDummyScraper, clearScraper,removeFromFolderScrapper } = ScrapperSlice.actions

export default ScrapperSlice.reducer;
